import { render, staticRenderFns } from "./Highschoolers.vue?vue&type=template&id=666310e8&scoped=true&lang=pug&"
import script from "./Highschoolers.vue?vue&type=script&lang=js&"
export * from "./Highschoolers.vue?vue&type=script&lang=js&"
import style0 from "./Highschoolers.vue?vue&type=style&index=0&id=666310e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666310e8",
  null
  
)

export default component.exports